export const initScrollAnimations = () => {};

export type ScrollAnimationFunctions = typeof _scrollAnimation;

export const _scrollAnimation = {
  init: (
    $el: HTMLElement,
    options?: {
      threshold?: number | number[];
      rootMargin?: string;
      verticalRatio?: number;
      horizontalRatio?: number;
      once?: boolean;
      exitDuration?: number;
    }
  ) => {
    const {
      threshold = [0, 0.5, 1],
      rootMargin = "0px",
      verticalRatio = 0.5,
      horizontalRatio = 0.5,
      once = false,
      exitDuration = 550,
    } = options || {};

    const state = window.Alpine.reactive({
      entering: false,
      exiting: false,
      timeout: null,
    });

    const observer = new IntersectionObserver(
      ([entry]) => {
        const rect = entry.intersectionRect;
        const bounding = entry.boundingClientRect;

        const horizontalVisible = rect.width / bounding.width >= horizontalRatio;
        const verticalVisible = rect.height / bounding.height >= verticalRatio;
        const isVisible = horizontalVisible && verticalVisible;

        if (isVisible && entry.isIntersecting) {
          state.entering = true;
          state.exiting = false;

          if (once) {
            observer.disconnect();
          }
        }

        if (!isVisible && !entry.isIntersecting) {
          if (once) return;

          if (state.entering) {
            state.exiting = true;
            state.entering = false;
            setTimeout(() => {
              if (!state.entering) state.exiting = false;
            }, exitDuration);
          }
        }
      },
      { threshold, rootMargin }
    );

    observer.observe($el);

    return {
      scrollAnimationState: state,
      destroy() {
        observer.disconnect();
      },
    };
  },
};

window._scrollAnimation = _scrollAnimation;
